import { JetView } from 'webix-jet';
import { devConfig } from 'config/config';

/**
 * Class representing the commission report view.
 * @extends JetView
 */
export default class tableComissionReportView extends JetView {
    /**
     * Configures the view layout and data structure.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        var leftSplit = 1; // Variable to determine left split for datatable

        // Adjust leftSplit based on screen size
        webix.ready(function () {
            if (screen.width < 500 || screen.height < 500) {
                leftSplit = 0; // No left split for small screens
            } else {
                leftSplit = 1; // Enable left split for larger screens
            }
        });

        return {
            view: 'pivot', // Pivot table view
            id: 'pivot', // Unique identifier for the pivot table
            scroll: true, // Enable scrolling
            totalColumn: true, // Show total column
            footer: true, // Show footer
            structure: {
                rows: ['NameAffiliate'], // Rows configuration
                columns: ['TypeName'], // Columns configuration
                values: [
                    { name: 'AmountBase', operation: 'sum' }, // Sum operation for AmountBase
                    { name: 'Amount', operation: 'sumcomission' }, // Custom sum operation for Amount
                    { name: 'Bets', operation: 'sum' }, // Sum operation for Bets
                    { name: 'Winnings', operation: 'sum' }, // Sum operation for Winnings
                    { name: 'Bonus', operation: 'sum' }, // Sum operation for Bonus
                ],
                filters: [{ name: 'NameAffiliate', type: 'text' }], // Filters configuration
            },
            datatable: {
                leftSplit: leftSplit, // Set left split based on screen size
            },
            on: {
                /**
                 * Event triggered before rendering the pivot table.
                 * @param {Object} config - The configuration object for the pivot table.
                 */
                onBeforeRender: function (config) {
                    var columns = config.header; // Get columns from header
                    config.header[0].css = 'name_column'; // Apply CSS class to the first column

                    var filters = config.filters; // Get filters
                    if (filters != undefined) {
                        for (var j = 0; j <= filters.length; j++) {
                            if (filters[j] != undefined) {
                                // Localize filter labels
                                if (filters[j].cols[0].label.indexOf('NameAffiliate') !== -1) {
                                    filters[j].cols[0].label = _('Nombre Afiliador');
                                }
                            }
                        }
                    }

                    // Localize column headers
                    for (var i = 1; i < columns.length; i++) {
                        var format = webix.Number.numToStr({
                            groupDelimiter: '',
                            groupSize: 3,
                            decimalDelimiter: ',',
                            decimalSize: 2,
                        });
                        columns[i].format = format; // Set number format for columns

                        // Update header text based on localization
                        if (columns[i].header[1].text.indexOf('AmountBase') !== -1) {
                            columns[i].header[1].text = _('Monto');
                        } else if (columns[i].header[1].text.indexOf('Amount') !== -1) {
                            columns[i].header[1].text = _('Comisión');
                        } else if (columns[i].header[1].text.indexOf('Bets') !== -1) {
                            columns[i].header[1].text = _('Apuestas');
                        } else if (columns[i].header[1].text.indexOf('Winnings') !== -1) {
                            columns[i].header[1].text = _('Premios');
                        } else if (columns[i].header[1].text.indexOf('Bonus') !== -1) {
                            columns[i].header[1].text = _('Bonos');
                        }
                    }
                },
                /**
                 * Event triggered before loading data into the pivot table.
                 */
                onBeforeLoad: function () {
                    this.showOverlay(
                        "<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>",
                    ); // Show loading overlay
                },
                /**
                 * Event triggered after data has been loaded into the pivot table.
                 */
                onAfterLoad: function () {
                    this.hideOverlay(); // Hide loading overlay
                },
            },
            /**
             * Event triggered when the pivot table is ready.
             */
            ready: function () {
                if (!this.count()) {
                    webix.extend(this, webix.OverlayBox); // Extend with overlay capabilities
                    this.showOverlay(
                        "<div class='no-data' style='margin:75px; font-size:18px;'>" + _('No hay datos') + '</div>', // Show no data message
                    );
                }
            },
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     */
    init() {
        webix.extend($$('pivot'), webix.OverlayBox); // Extend pivot with overlay capabilities
        const _ = this.app.getService('locale')._; // Localization service
        var url = devConfig.geturlApi() + 'es/Financial/GetComissionsResume2'; // API endpoint for fetching data

        // Event listener for filtering data
        this.on(this.app, 'depositReport:filter', (filterData) => {
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize query string

            // Build query string based on filter data
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'Datepicker') {
                        var date = object[i][1].split(' - ');
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else if (object[i][0] != 'Date') {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1];
                    } else if (object[i][0] == 'Date') {
                        var date = object[i][1].replace(' 00:00:00', '');
                        string1 = string1 + '&dateFrom=' + date;
                        string1 = string1 + '&dateTo=' + date;
                    }
                } else if (typeof object[i][1] === 'object') {
                    var object2 = Object.entries(object[i][1]); // Convert nested object to entries
                    for (var j = 0; j < object2.length; j++) {
                        if (object2[j][1] !== null) {
                            if (object2[j][0] === 'start') {
                                var d = new Date(object2[j][1]);
                                var dateFrom =
                                    'dateFrom=' +
                                    d.getFullYear() +
                                    ':' +
                                    ('00' + (d.getMonth() + 1)).slice(-2) +
                                    ':' +
                                    ('00' + d.getDate()).slice(-2) +
                                    ' ' +
                                    ('00' + d.getHours()).slice(-2) +
                                    ':' +
                                    ('00' + d.getMinutes()).slice(-2) +
                                    ':' +
                                    ('00' + d.getSeconds()).slice(-2);
                                string1 = string1 + '&' + dateFrom; // Append dateFrom to query string
                            } else if (object2[j][0] === 'end') {
                                var d = new Date(object2[j][1]);
                                var dateTo =
                                    'dateTo=' +
                                    d.getFullYear() +
                                    ':' +
                                    ('00' + (d.getMonth() + 1)).slice(-2) +
                                    ':' +
                                    ('00' + d.getDate()).slice(-2) +
                                    ' ' +
                                    ('00' + d.getHours()).slice(-2) +
                                    ':' +
                                    ('00' + d.getMinutes()).slice(-2) +
                                    ':' +
                                    ('00' + d.getSeconds()).slice(-2);
                                string1 = string1 + '&' + dateTo; // Append dateTo to query string
                            }
                        }
                    }
                }
            }

            $$('pivot').clearAll(); // Clear existing data in pivot table
            $$('pivot').load(url + '?start=0&count=1000000' + string1); // Load new data into pivot table
            $$('filterPopup').hide(); // Hide filter popup
        });

        // Add custom operation for summing commissions
        $$('pivot').addOperation('sumcomission', function (values, key, data, ids) {
            return $$('pivot').operations.sum(values); // Use default sum operation
        });

        // Add total operation for summing commissions
        $$('pivot').addTotalOperation('sumcomission', function (values, key, data) {
            var sum = 0,
                sumsc = 0; // Initialize sums
            if (data) {
                for (var i in data) {
                    var item = data[i];
                    if (item == '') {
                        item = 0; // Treat empty items as zero
                    }
                    if (
                        i.indexOf('_sumcomission_') > 0 &&
                        i.indexOf('AmountBase') == -1 &&
                        i.indexOf('webixtotal_') == -1
                    ) {
                        if (i.indexOf('(SC#)') >= 0) {
                            sumsc += parseFloat(item); // Sum special commission items
                        } else {
                            sum += parseFloat(item); // Sum regular items
                        }
                    }
                }
            }
            if (sumsc < 0) {
                sumsc = 0; // Ensure sumsc is not negative
            }
            sum = sum + sumsc; // Total sum
            if (data.$source) {
                return sum; // Return total if source exists
            } else {
                return $$('pivot').operations.sum(values); // Default sum operation
            }
        });
    }
}

// FILE DOCUMENTED
